import PromoCodesContainer from './PromoCodesContainer';

export default PromoCodesContainer;
